import * as ng from 'angular';
import * as Dto from './../../../data/interfaces';
import * as Core from './../../../core';

interface IUserResource extends ng.resource.IResourceClass<Dto.IUser> {
    resetPassword(params: Object, passwordResetRequest: Dto.IPasswordResetRequest): Dto.IUser; //TODO: Update interfaces and parameters
    forgotPasswordRequestLink(params: Object): Dto.IUser;
    userExists(params: Object): Dto.IUser;  
    changePassword(params:Object, request: Dto.IChangePasswordRequest): Dto.IUser;
    changeAnswer(params: Object, answer: Dto.ISecurityQuestionAnswer): Dto.IUser;
    search(user: Dto.IUserCriteria): ng.resource.IResourceArray<Dto.IUser>;
    sendInvite(params: any,  resetRequest?: Dto.IUserPasswordResetRequest): ng.resource.IResource<boolean>;
    unlockUser(params: any): ng.resource.IResource<boolean>;
}

let UserResourceFactory: Function =
    ($resource: ng.resource.IResourceService, exception: any, logger: any, SiteConfig: Core.ISiteConfigService): IUserResource => {

        return <IUserResource>$resource(
            SiteConfig.getResourceUri("users"),
            { id: '@id' } as any,
            new UserResource(SiteConfig) as any
        );
    };

UserResourceFactory.$inject = ['$resource', 'exception', 'logger', 'SiteConfig'];

class UserResource {

    constructor(private SiteConfig: Core.ISiteConfigService) {

    }

    public resetPassword: ng.resource.IActionDescriptor = {
        method: 'POST',        
        params: {
            reset: true
        }
    };

    public forgotPasswordRequestLink: ng.resource.IActionDescriptor = {
        method: 'POST',       
        params: {
            sendReset: true
        }
    };

    public userExists: ng.resource.IActionDescriptor = {
        method: 'GET',
       
        params: {
            exists: true,
            username: '@username'
        },
        transformResponse: (response, headerGetter) => {
            return { exists: response }
        }
    };

    public changePassword: ng.resource.IActionDescriptor = {
        url: this.SiteConfig.getResourceUri("passwords"),
        method: 'POST',
        params: {
            change: true
        }
    };

    public changeAnswer: ng.resource.IActionDescriptor = {
        url: this.SiteConfig.getResourceUri("passwords"),
        method: 'POST',
        params: {
            answer: true
        }
    };

    public search: ng.resource.IActionDescriptor = {
        method: 'POST',
        url: this.SiteConfig.getResourceUri("usersBulk"),
        isArray: true,
        params: {
            query: true
        }
    };

    public sendInvite: ng.resource.IActionDescriptor = {
        method: 'POST',
        url: this.SiteConfig.getResourceUri("passwords"),
        params: {
            delegateSendReset: true
        }
    };

    public unlockUser: ng.resource.IActionDescriptor = {
        url: this.SiteConfig.getResourceUri("passwords") + "/UnlockUser",
        method: 'POST'
    };

}

let User = {
    name: "User",
    factory: UserResourceFactory
};

export { User, IUserResource }
export default User;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/data/user.ts